<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                Charges
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <h5 class="title is-5">
                &pound;{{ outstandingAmount.AmountOS | currency }} needs to be paid before you move in
            </h5>

            <Notification v-if="! outstandingCharges">
                Loading charges...
            </Notification>

            <Notification v-if="outstandingCharges && ! outstandingCharges.length">
                No charges found.
            </Notification>

            <div v-if="outstandingCharges">
                <table class="table is-fullwidth is-bordered is-striped">
                    <tr>
                        <th>
                            Description
                        </th>
                        <th class="is-hidden-mobile">
                            Amount
                        </th>
                        <th class="is-hidden-mobile">
                            VAT
                        </th>
                        <th>
                            Total
                        </th>
                    </tr>

                    <tr
                        v-for="row in outstandingCharges"
                        :key="row.ChargeFK"
                    >
                        <td>
                            {{ row.strDescription }}
                        </td>
                        <td class="is-hidden-mobile">
                            &pound;{{ row.dblCharge | currency }}
                        </td>
                        <td class="is-hidden-mobile">
                            <b-tooltip :label="`VAT rate is ${row.dblVatRate }%`">
                                &pound;{{ row.dblVAT | currency }}
                            </b-tooltip>
                        </td>
                        <td>
                            &pound;{{ parseFloat(row.dblCharge) + parseFloat(row.dblVAT) | currency }}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <strong>
                                Total
                            </strong>
                        </td>
                        <td colspan="3">
                            <strong>
                                &pound;{{ totalAmountFormatted | currency }}
                            </strong>
                        </td>
                    </tr>
                    <tr v-if="paidAmount">
                        <td>
                            <strong>
                                Paid
                            </strong>
                        </td>
                        <td colspan="3">
                            <strong>
                                &pound;{{ paidAmount.ReceiptsTotal | currency }}
                            </strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong class="has-text-danger">
                                Outstanding
                            </strong>
                        </td>
                        <td colspan="3">
                            <strong class="has-text-danger">
                                &pound;{{ outstandingAmountFormatted | currency }}
                            </strong>
                        </td>
                    </tr>
                </table>

                <p v-if="$meta.features.tenants.bank_account || $meta.features.tenants.online_payments">
                    <b-button
                        type="is-info"
                        class="is-fullwidth"
                        @click="paymentModal"
                    >
                        Pay
                    </b-button>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification.vue';
import PaymentModal from './PaymentModal.vue';

export default {
    components: {
        Notification,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'property',
        ]),
        ...mapState('tenancyCharges', [
            'outstandingCharges',
            'outstandingAmount',
            'paidAmount',
            'total',
        ]),
        ...mapGetters('tenancyCharges', [
            'outstandingAmountFormatted',
            'totalAmountFormatted',
        ]),
    },

    mounted() {
        this.getInitialCharges();
        this.getInitialChargesPaid();
        this.getInitialChargesTotal();
    },

    methods: {
        getInitialCharges() {
            this.$store.dispatch('tenancyCharges/getOutstandingCharges', this.property.TenancyFK);
        },
        getInitialChargesTotal() {
            this.$store.dispatch('tenancyCharges/getTotal', this.property.TenancyFK);
        },
        getInitialChargesPaid() {
            this.$store.dispatch('tenancyCharges/getPaidAmount', this.property.TenancyFK);
        },
        paymentModal() {
            this.$parent.close();

            this.$buefy.modal.open({
                parent: this,
                component: PaymentModal,
                hasModalCard: true,
                props: {
                    balance: this.outstandingAmountFormatted,
                    link: {
                        name: 'tenancy-property-pay',
                        params: {
                            id: this.property.TenancyFK,
                        },
                    },
                },
            });
        },
    },
};
</script>
